import * as React from 'react';
import { BaseModel } from './BaseModel';
import { IQuestions } from '../interfaces';

export interface IQuestionModelProps {
    question?: string;
    quesNum?: string;
    type?: string;
    id?: string;
    quesName?: string;
    answer?: boolean;
    Questiontype?: string;
    questions?: IQuestions[];
}

export class QuestionModel extends BaseModel<IQuestionModelProps> {
    constructor(props: IQuestionModelProps) {
        super(props);
    }

    static resource = 'form-question';
}

export class QuestionModelDuplicate extends BaseModel<IQuestionModelProps> {
    constructor(props: IQuestionModelProps) {
        super(props);
    }

    static resource = 'form-question-duplicate';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/QuestionModel.tsx